import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    shippingCostCents: String,
    deliveryTime: String
  }

  calculateShippingRates(event) {
    const zipCode = event.target.value

    if (zipCode.length === 8) {
      fetch('/shipping_rates', {
        method: 'POST',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({ zip_code: zipCode })
      }).then(async response => {
        if (response.ok) {
          const html = await response.text()
          Turbo.renderStreamMessage(html)
        }
      }).catch(error => {
        console.error('There was a problem when trying to calculate shipping rates', error)
      })
    }
  }

  selectShipping(event) {
    const shippingMethod = event.target.value

    if (shippingMethod) {
      fetch('/cart', {
        method: 'PATCH',
        headers: {
          'Accept': 'text/vnd.turbo-stream.html',
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        },
        body: JSON.stringify({
          cart: {
            shipping_method: shippingMethod,
            shipping_cost_cents: this.shippingCostCentsValue,
            delivery_time: this.deliveryTimeValue
          }
        })
      }).then(async response => {
        if (response.ok) {
          const html = await response.text()
          Turbo.renderStreamMessage(html)
        }
      }).catch(error => {
        console.error('There was a problem when trying to select shipping rate', error)
      })
    }
  }
}
